import { useEffect } from "react";

interface SEOProps {
  title: string;
  description?: string;
  keywords?: string;
  noIndex?: boolean;
}

export const SEO = ({ title, description, keywords, noIndex }: SEOProps) => {
  useEffect(() => {
    document.title = `${title} | Command X`;
    const metaDesc = document.querySelector('meta[name="description"]');
    if (description) {
      if (metaDesc) {
        metaDesc.setAttribute("content", description);
      } else {
        const meta = document.createElement("meta");
        meta.name = "description";
        meta.content = description;
        document.head.appendChild(meta);
      }
    }
    if (noIndex) {
      let robot = document.querySelector('meta[name="robots"]');
      if (!robot) {
        robot = document.createElement("meta");
        (robot as HTMLMetaElement).name = "robots";
        document.head.appendChild(robot);
      }
      robot.setAttribute("content", "noindex");
    }
  }, [title, description, keywords, noIndex]);

  return null;
};
